// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wS8FFznsfjFOIlflS92d{display:grid;width:350px}.wS8FFznsfjFOIlflS92d button:hover{opacity:.5}", "",{"version":3,"sources":["webpack://./src/components/Quiz/QuizCard.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,WAAA,CAEE,mCACE,UAAA","sourcesContent":[".QuizCard {\n  display: grid;\n  width: 350px;\n\n    button:hover {\n      opacity: .5;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"QuizCard": "wS8FFznsfjFOIlflS92d"
};
export default ___CSS_LOADER_EXPORT___;
